var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWanchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94891 20.7278L8.98626 19.544L14.031 22.5035L19.0137 19.544L21.1131 20.7278L14.031 25L6.94891 20.7278Z",
    fill: "#2FBDF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69231 8.8562L7.45049 10.04V16.6955L14 12.7282L20.6126 16.6955V10.04L23.3077 8.8562V21.4004L14 15.8323L4.69231 21.4004V8.8562Z",
    fill: "#0F68AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00567 8.34391L14 3L23.0574 8.34391L20.6126 9.36848L14 5.49648L7.45049 9.36848L5.00567 8.34391Z",
    fill: "#2FBDF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWanchain);
export default __webpack_public_path__ + "static/media/wanchain.4f0c9a4a7db44042fb69c05ce0cf7f29.svg";
export { ForwardRef as ReactComponent };